export const getUserIdFromUrl = () => {
  try {
    const url = new URL(window.location.href);
    const pathParts = url.pathname.split("/").filter(Boolean);
    
    console.log('URL path parts:', pathParts);
    
    // /userId/admin formatında ise userId'yi al
    if (pathParts.length >= 2 && pathParts[pathParts.length - 1] === 'admin') {
      const userId = pathParts[pathParts.length - 2] || "";
      console.log('Admin formatında userId bulundu:', userId);
      return userId;
    }
    
    // Normal durumda son parçayı al
    const userId = pathParts[pathParts.length - 1] || "";
    console.log('Normal formatda userId bulundu:', userId);
    return userId;
  } catch (error) {
    console.error('getUserIdFromUrl hatası:', error);
    return "";
  }
};
